module.exports = __webpack_public_path__ + "img/ic_marker_my_loc.1c610f98.png";